// QUERY_KEY

/** 地区 key */
export const REGION_KEY = 'REGION_KEY'

/** 应用中心 */
export const APPLICATION_KEY = 'APPLICATION_KEY'
